// =============================================================================
// Seeded PRNG (Mulberry32)
// =============================================================================

export type RngFn = () => number;

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return hash >>> 0;
}

function mulberry32(seed: number): RngFn {
  let state = seed;
  return () => {
    state |= 0;
    state = (state + 0x6d2b79f5) | 0;
    let t = Math.imul(state ^ (state >>> 15), 1 | state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function createRng(seed: string): RngFn {
  if (!seed) {
    return Math.random;
  }
  return mulberry32(hashString(seed));
}

// =============================================================================
// Core math helpers
// =============================================================================

export function boxMullerNormal(mean: number, sd: number, rng: RngFn): number {
  let u1: number;
  do {
    u1 = rng();
  } while (u1 === 0);
  const u2 = rng();
  const z = Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
  return mean + sd * z;
}
